import {NOTICE_TYPE} from './types';

export const getNotification = data => ({
  type: NOTICE_TYPE,
  payload: data,
});
